module.exports = __webpack_public_path__ + "media/images/emblems/Fraeschels-coat_of_arms-109d26907aac622fe1e961bc83ebd00b.svg";